export default __webpack_public_path__ + "static/image-457d4ed510ccdd8c3c48671845027a09.jpg";